import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Download, HeartHandshake } from "lucide-react";

const ROWS = [
  { d: "Built world-class infrastructure from nothing",              m: "We build homes for everyone — not just the few" },
  { d: "Opened global investment to a new region",                   m: "We open home ownership to ordinary citizens" },
  { d: "Offers temporary residency & lease rights",                  m: "We register permanent freehold title in your name on completion" },
  { d: "Works best for large budgets & high incomes",                m: "We work with modest deposits — no strict credit checks" },
  { d: "Requires status proofs & high entry thresholds",             m: "We never ask about your life abroad — only your citizenship" },
  { d: "Focuses on global demand & luxury growth",                   m: "We prioritise local families, legacy & stability" },
];

export default function MavulaVsDubai({ withDownload = true }) {
  return (
    <section className="py-14 md:py-20 border-t mv-hairline" data-testid="mavula-vs-dubai">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Different priorities, not comparison</span></div>
        <h2 className="font-display text-3xl md:text-5xl mv-green-text mt-3 leading-[1.05]">
          What Dubai focuses on. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>What MAVULA focuses on.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-[15px]" style={{ color: "var(--mv-muted)" }}>
          A respectful side-by-side of priorities — not a competitor comparison. Dubai has built something remarkable. MAVULA has a different mission: home ownership for Southern African citizens.
        </p>

        <div className="mt-8 mv-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-[14px]">
              <thead>
                <tr className="mv-green-bg text-white">
                  <th className="p-3 md:p-4 text-left text-[11px] uppercase tracking-[0.2em] font-semibold">What Dubai achieved</th>
                  <th className="p-3 md:p-4 text-left text-[11px] uppercase tracking-[0.2em] font-semibold" style={{ background: "rgba(212,175,55,0.24)" }}>How MAVULA goes further</th>
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r, i) => (
                  <tr key={r.d} className="border-b mv-hairline last:border-0" style={{ background: i % 2 ? "rgba(0,0,0,0.02)" : "#fff" }}>
                    <td className="p-3 md:p-4 align-top" style={{ color: "var(--mv-muted)" }}>
                      {r.d}
                    </td>
                    <td className="p-3 md:p-4 align-top" style={{ background: "linear-gradient(180deg, rgba(212,175,55,0.06), rgba(10,59,40,0.03))" }}>
                      <div className="mv-green-text font-semibold">{r.m}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Kind core message */}
        <div className="mt-8 mv-card p-6 md:p-8 flex items-start gap-4" style={{ background: "linear-gradient(135deg, rgba(10,59,40,0.05), rgba(212,175,55,0.12))" }}>
          <HeartHandshake size={28} className="mv-green-text shrink-0" style={{ color: "var(--mv-gold)" }}/>
          <div>
            <div className="text-[11px] uppercase tracking-[0.22em]" style={{ color: "var(--mv-gold)" }}>Our Position</div>
            <p className="mt-2 font-display text-xl md:text-2xl mv-green-text leading-snug">
              "We honour what others have built —{" "}
              <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>
                we build something for yours.
              </span>"
            </p>
          </div>
        </div>

        {withDownload && (
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/why-mavula" className="btn-gold" data-testid="vs-dubai-why">
              See all investor advantages <ArrowRight size={16}/>
            </Link>
            <a href="/downloads/Why-MAVULA.pdf" download="Why-MAVULA.pdf" className="btn-ghost inline-flex items-center gap-2" data-testid="vs-dubai-download">
              <Download size={16}/> Download One-Pager
              <span className="text-[9.5px] font-bold uppercase tracking-[0.18em] px-1.5 py-0.5 rounded-full ml-1" style={{ background: "rgba(212,60,60,0.14)", color: "#8a2020" }}>SAMPLE</span>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
